import { BUTTON_SIZE, BUTTON_TYPE, DSButton, DSModal } from '@repo/design-system/index'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { HighlightOverviewResponse } from '../../../../../model/caf.interface'
import { useCafHighlightListV5 } from '../../../../../modules/apis/webview/caf'
import useAppRouter from '../../../../../modules/hooks/common/useAppRouter'
import { n_caf } from '../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { COLORS } from '../../../../../modules/vars'
import useHighlightSortedList from '../utils/useHighlightSortedList'

const useHighlightEditPopup = () => {
  const router = useAppRouter()
  const { edit } = router.query
  const [showEditPopup, setShowEditPopup] = useState(false)

  useEffect(() => {
    if (edit === 'true') {
      setShowEditPopup(true)
      const next = router.asPath.replace('edit=true', 'edit=editing')
      router.push(next)
    }
  }, [edit])

  return {
    showEditPopup,
    setShowEditPopup,
  }
}
export const HighlightEditPopupComponent = ({ showEditPopup, setShowEditPopup }) => {
  const router = useAppRouter()
  const { t } = useTranslation()
  const { lessonId, edit } = router.query
  const { data, refetch, isFetched } = useCafHighlightListV5<HighlightOverviewResponse>({
    lessonId: +lessonId,
    pinned: false,
    recommended: false,
    show_details: false,
  })
  const options = [
    { label: t(n_caf.highlight_list.sort_optn1), value: 1, name: 'recommended' },
    { label: t(n_caf.highlight_list.sort_optn2), value: 2, name: 'count' },
    { label: t(n_caf.highlight_list.sort_optn3), value: 3, name: 'category' },
  ]

  const listData =
    data?.highlights?.map((item) => {
      return {
        ...item,
        zscore_sum: item.zscore, //map
        average_count: item.count,
        tag: item.highlight_tag,
      }
    }) || []
  const [sortOption, setSortOption] = useState(options[0])
  const content = useHighlightSortedList(listData, sortOption, () => null, true)
  return (
    <DSModal
      id="CafHighlightEditPopup"
      isOpen={showEditPopup}
      setIsOpen={setShowEditPopup}
      size="xl"
      className="max-h-[700px]"
    >
      <DSModal.Title>{t(n_caf.highlight_list_edit.title)}</DSModal.Title>
      <DSModal.Content className="max-h-[700px] overflow-y-scroll">
        <div className="mr-auto mt-[8px] flex flex-none flex-row items-start justify-start">
          {options.map((option, i) => (
            <DSButton
              type={BUTTON_TYPE.OUTLINE}
              key={`${option.label}${option.name}`}
              size={BUTTON_SIZE.SM}
              onClick={() => setSortOption(options[i])}
              customBorderColor={option.value === sortOption.value ? COLORS.PURPLE500 : COLORS.GRAY300}
              className={classNames('mr-[8px] !w-auto !cursor-pointer !rounded-[8px]')}
            >
              <DSButton.Label
                className={classNames('whitespace-nowrap', {
                  '!text-purple-500': option.value === sortOption.value,
                  '!text-black': option.value !== sortOption.value,
                })}
              >
                {option.label}
              </DSButton.Label>
            </DSButton>
          ))}
        </div>
        <div className="mt-[16px] flex w-full items-center justify-center rounded-[6px] border-[1px] border-gray-100 bg-gray-50 px-[16px] py-[12px] text-[14px] text-gray-700">
          {t(n_caf.highlight_list_edit.info)}
        </div>
        {content}
      </DSModal.Content>
      <DSModal.ButtonContainer direction="horizontal">
        <DSButton size={BUTTON_SIZE.MD} onClick={() => setShowEditPopup(false)} type={BUTTON_TYPE.OUTLINE}>
          <DSButton.Label className="whitespace-nowrap">{t(n_caf.statistic.bottomsheet_cancel)}</DSButton.Label>
        </DSButton>
        <DSButton size={BUTTON_SIZE.MD} onClick={() => setShowEditPopup(false)}>
          <DSButton.Label className="whitespace-nowrap">{t(n_caf.statistic.bottomsheet_apply)}</DSButton.Label>
        </DSButton>
      </DSModal.ButtonContainer>
    </DSModal>
  )
}
export default useHighlightEditPopup
